// extracted by mini-css-extract-plugin
module.exports = {"btn":"BtnOpenApp_btn__18e2h"};